import messageBox from 'element-ui/lib/message-box';
import i18n from '@/main';

const key = 'consensoDenuncia';

export function setLocalStorage(value) {
    window.localStorage[key] = value;
    return window.localStorage[key];
}

function setConsensoDenuncia() {
    const usuarioLogado = JSON.parse(sessionStorage.getItem('dadosUsuario'));
    const usuario = usuarioLogado?.username || '';
    const stringify = JSON.stringify({
        usuario,
        data: new Date().toISOString()
    });

    setLocalStorage(stringify);
}

function consensoInvalido() {
    const consenso = JSON.parse(window.localStorage?.[key] || '{}');
    const usuarioLogado = JSON.parse(sessionStorage.getItem('dadosUsuario'));
    const usuario = consenso?.usuario || '';
    const data = consenso?.data || '';

    if (usuario !== usuarioLogado?.username) return true;
    if (!data) return true;

    const dataArmazenada = new Date(data);
    const dataAtual = new Date();
    const diferencaMilissegundos = dataAtual - dataArmazenada;
    const diferencaEmHoras = diferencaMilissegundos / (1000 * 60 * 60);
    const tem1dia = diferencaEmHoras > 24;

    return tem1dia;
}

export function showDialogConsenso() {
    return messageBox.confirm(
        i18n.t('denuncia.messages.dialog_message'),
        i18n.t('denuncia.messages.dialog_title'),
        {
            confirmButtonText: i18n.t('denuncia.messages.dialog_confirm'),
            cancelButtonText: i18n.t('denuncia.messages.dialog_cancel'),
            customClass: 'dialog-consenso'
        }
    );
}

const beforeEnter = (to, from, next) => {
    const consenso = consensoInvalido();

    if (consenso) {
        showDialogConsenso()
            .then(res => {
                if (res === 'confirm') {
                    next();
                    setConsensoDenuncia();
                }
            })
            .catch(() => {
                next({ name: 'Home' });
            });
    } else {
        next();
    }
};

export default beforeEnter;
